import { ClientJS } from "clientjs";
import sensorHelper from "sensors-plugins";
import Vue from "vue";

function getEnv() {
  return (window._global && window._global._ENV) || "dev";
}

export const initSensor = account => {
  const client = new ClientJS();

  if (!account) {
    console.warn("[Sensors] account 为空，跳过初始化");
    return;
  }

  const sensorsConfig = {
    isProduction: getEnv() === "production",
    isLogInfo: true,
    isTrackPageviewGrey: false,
    systemCode: "ESG-CR-CORE",
    productCode: "stu-prs",
    distinctId: String(account), // 确保是字符串
    showLog: false,
    platformType: client.getOS(),
    platformName: "H5"
  };

  // init() 可能返回 Promise 也可能同步
  const result = sensorHelper.init(sensorsConfig);

  if (result && typeof result.then === "function") {
    // 返回 Promise
    result
      .then(sensorsInstance => {
        console.log("[Sensors] 初始化成功 (async)", sensorsInstance);
        Vue.prototype.$sensors = sensorsInstance;
      })
      .catch(err => {
        console.error("[Sensors] 初始化失败", err);
      });
  } else {
    // 同步返回（H5 模式），result 即 publicMethods 返回的 clickFunc（含 .Click / .track）
    console.log("[Sensors] 初始化成功 (sync)", result);
    Vue.prototype.$sensors = result;
  }
};



// WEBPACK FOOTER //
// ./src/countly.js